import styled from "styled-components"
import { Link } from "gatsby";
import { ReactSVG } from "react-svg"
import { TABLET_MAX_WIDTH, MOBILE_MIN_WIDTH } from "@constants"

export const StyledFooterWrapper = styled.div`
  padding: 80px 163px 40px 163px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 78vw;
  gap: 40px;

  & p {
    color: var(--main-blog-color);
  }

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    padding: 50px 133px 20px 103px;
    width: 70vw;
  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    width: 90vw;
    padding: 15px;
  }
`

export const StyledFooterContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.83fr;
  align-items: center;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

export const StyledLogoIconContainer = styled.div``

export const StyledLogoIcon = styled(ReactSVG)``

export const StyledNavigationalLinksWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border-top: 0.0625rem solid rgba(196, 177, 128, 0.6);
  border-bottom: 0.0625rem solid rgba(196, 177, 128, 0.6);

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    justify-items: center;
  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    grid-template-columns: repeat(1, 1fr);
    justify-items: start;
  }
`

export const StyledNavigationalLinksContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const StyledAboutCompanyWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr;
  align-items: center;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const StyledCopyrightWarning = styled.div`
  color: rgba(37, 37, 37, 0.60);
  font-size: 0.875rem;
  line-height: 1.5rem;
  letter-spacing: 0.26px;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    text-align: center;
  }
`

export const StyledNavigationalLinksBlockTitle = styled.p`
  color: gray !important;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.26px;
`

export const StyledSocialMediaContainer = styled.div`
  display: flex;
  
  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    justify-content: center;
  }
`

export const StyledNavigationalLinkContainer = styled.div``

export const StyledSocialMediaItemContainer = styled.a`
  border-radius: 0.0625rem;
  height: 2.125rem;
  width: 2.125rem;
  border: 0.0625rem solid #C4B180;
  background: rgba(196, 177, 128, 0.10);
  margin-right: 1.125rem;

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    background: rgba(196, 177, 128, 0.30);
  }

  &:active {
    background: rgba(196, 177, 128, 0.40);
  }
`;

export const StyledSocialMediaItem = styled(ReactSVG)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.125rem;
  width: fit-content;
  margin: 0.5rem auto;

  & svg {
    height: 1rem;
    width: 1.25rem;
  }
`;

export const StyledAboutCompanyContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    display: grid;
    justify-content: center;
    gap: 16px;
  }
`;

export const StyledCompanyRulesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    justify-content: center;
    margin-top: 16px;
  }
`;

export const StyledPrivacyPolicy = styled.span`
  color: var(--main-blog-color);
  font-family: Nunito Sans;
  font-size: 0.875rem;
  line-height: 171.429%;
  letter-spacing: 0.28px;

  &:hover {
    color: var(--main-gold);
  }
`;

export const StyledGDPR = styled.span`
  color: var(--main-blog-color);
  font-family: Nunito Sans;
  font-size: 0.875rem;
  line-height: 171.429%;
  letter-spacing: 0.28px;

  &:hover {
    color: var(--main-gold);
  }
`;

export const StyledInternalLink = styled(Link)`
  text-decoration: none;
  min-width: fit-content;
`;